/**
*
*   Redeem Products
*       - The featured products collection on the home page
*
**/
'use client';

import Button from '@/components/button';
import ProductCard from '@/components/collection/product-card';
import Storefront from '@/libraries/shopify/class';
import { useTranslations } from 'next-intl';
import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

//Build the Element
export default function Redeem( props ){

	const t                     = useTranslations(),
		ref                     = useRef(),
		[products, setProducts] = useState([]),
		[swiper, setSwiper]     = useState({
			instance:   null,
			first:      true,
			last:       false
		}),
		Parameters = {

			//Swiper Settings
			spaceBetween:   10,
			breakpoints:    {
				0: {
					slidesPerView: 2
				},
				850: {
					slidesPerView: 3
				},
				1100: {
					slidesPerView: 4
				}
			},

			onSwiper: swiper => setSwiper({
				instance:       swiper,
				first:          swiper.isBeginning,
				last:           swiper.isEnd
			}),

			onSlideChange: swiper => setSwiper({
				instance:       swiper,
				first:          swiper.isBeginning,
				last:           swiper.isEnd
			}),

			onTransitionEnd: swiper => setSwiper({
				instance:       swiper,
				first:          swiper.isBeginning,
				last:           swiper.isEnd
			}),

			onResize: swiper => setSwiper({
				instance:       swiper,
				first:          swiper.isBeginning,
				last:           swiper.isEnd
			})

		};



	/**
	*
	*   Resize the nav to the center of the categories
	*
	**/
	useEffect( () => {

		/**
		*
		*  Load the Products
		*
		*
		**/
		( async () => {

			const data = ( await Storefront.Collection.load('essential-oil-blends') )?.body;

			//Get Product Data
			const products = (
				await Storefront.Products.get(
					data.products.map( (product) => product.id )
				)
			)?.body;

			//Products
			data.products.forEach( (product,i) => {
				products.forEach( productData => {
					if( productData.id == product.id ){
						data.products[i] = { ...data.products[i] , ...productData };
					}
				});
			});

			//Set the Data
			setProducts(
				data.products.filter( product => {
					return product.tags.find( tag => tag.toLowerCase() == 'hidden') === undefined && product.handle != 'gift-card';
				})
			);

		})();

		/**
		*
		*  RESIZER
		*   - The Resizer Function to align the nav to the center of the image
		*
		*   Params:
		*       n/a
		**/
		const obj = {
			resizer: (e) => {

				const $container  = ref.current,
					$nav        = $container.querySelector('nav'),
					height      = $container.querySelector('.collection').offsetHeight;

				$nav.style.top = `${ ( height / 2 ) - ( $nav.offsetHeight / 2 )  }px`;

			}
		};

		//Add the resizer event
		window.addEventListener('resize', obj.resizer );

		//Dispatch the event to start it
		obj.resizer();

		//Cleanup
		return () => window.removeEventListener('resize', obj.resizer );

	},[swiper]);

	//Return
	return (
		<section id="redeem" className="container" ref={ref}>
			<header>
				<h2>{ t('Pages.Rewards.redeem.title') }</h2>
				<p>{ t('Pages.Rewards.redeem.description') }</p>
			</header>
			<div>
				<Swiper { ...Parameters } className="list collection">
					{products.map( (product, i)=>{
						return (
							<SwiperSlide className="category" key={i}>
								<ProductCard key={ product.id } product={ product } type={ 'points' } />
							</SwiperSlide>
						);
					})}
				</Swiper>
				<nav>
					<Button onClick={ () => swiper.instance.slidePrev() } disabled={ swiper.first } hidden={ swiper.first }>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
							<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</Button>
					<Button onClick={ () => swiper.instance.slideNext() } disabled={ swiper.last } hidden={ swiper.last }>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
							<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</Button>
				</nav>
			</div>
			<footer className="buttons">
				<Button href={ '/collections/all' }>
					{ t('Pages.Rewards.redeem.button') }
				</Button>
			</footer>
		</section>
	);

}